import { localLogout } from './API/auth';

export default function handle401(err): void {
  if (err.response.status === 401) {
    localLogout();
  }
  throw err;
}
